var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-send-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.9165 11.9595C7.9165 12.7678 8.5415 13.4178 9.30817 13.4178H10.8748C11.5415 13.4178 12.0832 12.8512 12.0832 12.1428C12.0832 11.3845 11.7498 11.1095 11.2582 10.9345L8.74984 10.0595C8.25817 9.88451 7.92485 9.61785 7.92485 8.85118C7.92485 8.15117 8.4665 7.57617 9.13317 7.57617H10.6998C11.4665 7.57617 12.0915 8.22617 12.0915 9.03451",
    stroke: "#B3261E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 6.75V14.25",
    stroke: "#B3261E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3332 10.5013C18.3332 15.1013 14.5998 18.8346 9.99984 18.8346C5.39984 18.8346 1.6665 15.1013 1.6665 10.5013C1.6665 5.9013 5.39984 2.16797 9.99984 2.16797",
    stroke: "#B3261E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3333 5.5013V2.16797H15",
    stroke: "#B3261E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.1665 6.33463L18.3332 2.16797",
    stroke: "#B3261E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/moneyIcon.9d81cf9606f647d5dead042f22fc908f.svg";
export { ForwardRef as ReactComponent };